<template>
  <Navbar />
  <!-- 主要內容區塊錨點 (搭配 Skip Link 與 Alt+C 快速鍵) -->
  <div id="main-content" tabindex="-1" class="main-content-anchor">
    <a
      id="accesskey-c"
      href="#accesskey-c"
      accesskey="C"
      class="accesskey-brick sr-only-focusable"
      title="主要內容區塊，快捷鍵：Alt+C"
      aria-label="主要內容區塊"
    >:::</a>
  </div>
  <div class="register">
    <LoginCard />
  </div>
</template>

<script setup>
import Navbar from "../components/Navbar.vue";
import LoginCard from "../components/LoginCard.vue";
import { useRouter, useRoute } from "vue-router";
import { computed } from "vue";
import { useLayoutStore } from "@/stores/layout";

const router = useRouter();
const route = useRoute();
const layoutStore = useLayoutStore();

const stepMap = [{ path: "/sign-in", component: LoginCard }];

const currentComponent = computed(() => {
  const match = stepMap.find((s) => s.path === route.path);
  return match ? match.component : LoginCard;
});

function handleNextStep() {
  const index = stepMap.findIndex((s) => s.path === route.name);
  const next = stepMap[index + 1];
  if (next) {
    router.push({ name: next.path });
  }
}
</script>

<style scoped>
.register {
  width: 100%;
  min-height: 100vh;
  background-color: var(--color-primary-bg);
  background: linear-gradient(180deg, #f9f9f9, #a7dff1);
  display: flex;
  justify-content: center;
  padding: 95px 16px 24px; /* ✅ 上下都有 padding，左右暫時為 0 */
  box-sizing: border-box;
  margin-top: v-bind("layoutStore.pageMarginTop");
}

@media (max-width: 768px) {
  .register {
    margin-top: v-bind('layoutStore.showAnnouncementBanner ? "160px" : "55px"');
  }
}

/* ✅ 手機版左右 padding */
@media (max-width: 1024px) {
  .register-form {
    padding: 0 24px;
  }
}
</style>
